// extracted by mini-css-extract-plugin
module.exports = {"container":"TimestampSummary_container__2AtTu","badges":"TimestampSummary_badges__3-Qv5","badge":"TimestampSummary_badge__ymXA-"};